import React from 'react';
import _ from 'lodash';

import slugify from 'slugify';
import { HTMLContent } from '~components/Content';
import { TableData, TableRow } from '~components/common/Table';
import { idSummaries } from '~utils/faqAnswerUtils';
import { rowRendererProps } from '../propTypes';
import StateEarlyVotingDate from '../../common/StateEarlyVotingDate';

export default function EarlyVotingCalendarRowRenderer({ state }) {
  const stateName = state.fieldValue;

  const stateData = _.keyBy(state.nodes, 'field_type');

  const earlyVotingStarts = stateData.early_voting_starts
    ? stateData.early_voting_starts.text
    : 'N/A';
  const earlyVotingEnds = stateData.early_voting_ends
    ? stateData.early_voting_ends.text
    : 'N/A';
  const idType =
    stateData.id_type_in_person_voting &&
    stateData.id_type_in_person_voting.text;

  const hasEarlyVoting =
    earlyVotingStarts.trim() &&
    earlyVotingEnds.trim() &&
    earlyVotingStarts.toUpperCase().trim() !== 'N/A' &&
    earlyVotingEnds.toUpperCase().trim() !== 'N/A';

  const stateSlug = slugify(stateName.toLowerCase());

  return (
    <TableRow id={stateSlug}>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <TableData data-title='Early voting starts'>
        <div>
          <StateEarlyVotingDate timePeriod='start' stateData={stateData} />
        </div>
      </TableData>
      <TableData data-title='Early voting ends'>
        <div>
          <StateEarlyVotingDate timePeriod='end' stateData={stateData} />
        </div>
      </TableData>
      <TableData>
        <div>
          {hasEarlyVoting && stateData.id_laws_in_person_voting ? (
            <div className='space-y-3'>
              <p className='font-bold'>{idSummaries[idType]}</p>
              <HTMLContent
                content={stateData.id_laws_in_person_voting.html}
                className='space-y-3'
              />
            </div>
          ) : (
            'N/A'
          )}
        </div>
      </TableData>
    </TableRow>
  );
}

EarlyVotingCalendarRowRenderer.propTypes = rowRendererProps;
